import { render, staticRenderFns } from "./Predict.vue?vue&type=template&id=b1bdca20&scoped=true"
import script from "./Predict.vue?vue&type=script&lang=js"
export * from "./Predict.vue?vue&type=script&lang=js"
import style0 from "./Predict.vue?vue&type=style&index=0&id=b1bdca20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bdca20",
  null
  
)

export default component.exports